/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Firestore Composable for Writing and Updating a new Firebase Document
/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Example Usage:
/// await useSetDoc('pipelines', '1708739778696', { data })

import type { Firestore } from 'firebase/firestore'
import { doc, setDoc } from 'firebase/firestore'

/// Note: If document already exists, data passed will be merged rather then all data being overwritten
/// To force a full overwrite, pass forceOverwrite = true
export default async function (docPath: string, docId: string, data: object = {}, forceOverwrite: boolean = false) {
  // If docPath doesn't start with 'accounts/' then prepend it
  const { accountId } = storeToRefs(useGlobalsStore())

  // Data Parsed From Convert Nested Object to Dot Notation
  if (!docPath.startsWith('accounts') && !docPath.startsWith('users'))
    docPath = `accounts/${accountId.value}/${docPath}`

  // Create New Document
  const { $firestore } = useNuxtApp()
  const response = await setDoc(doc($firestore as Firestore, docPath, docId), data, { merge: !forceOverwrite })

  return response
}
